import { phpRequest } from "./phpRequest";

export const cancelSubscriptionAPI = (valueAddedServiceId) => {
  return phpRequest.post("/subscribe/void", {
    subscribe_value_added_service_id: valueAddedServiceId,
  });
};
